<template>
  <section>
    <social-header v-if="currentEnv" title="我的奖励"></social-header>
    <!--头部-->
    <!--我的奖励-->
    <div class="order-nav">
      <ul>
        <li v-if="!isChangeCommissionTypeDisabled"
          v-on:click.stop="showCommissionType"
          v-bind:class="{active:isShowCommissionType}"
        >奖励类型<em
            class="iconfont_M icon-more_M"
            v-stat:click="{name:'type'}"
          ></em></li>
        <li v-else
        >奖励类型<em
            class="iconfont_M icon-more_M"
            v-stat:click="{name:'type'}"
          ></em></li>
        <li
          v-on:click.stop="showDateScope"
          v-bind:class="{active:isShowDateScope}"
        >发放日期<em
            class="iconfont_M icon-more_M"
            v-stat:click="{name:'scope'}"
          ></em></li>
      </ul>
      <div
        class="order-nav-list"
        v-show="isShowCommissionType"
      >
        <p
          v-for="item in commissionTypeKeys"
          v-bind:key="item.key"
          v-bind:class="{active:item.value==commissionType}"
          v-on:click="setCommissionTypeHandler(item.value)"
        >{{item.key}}<em class="iconfont_M icon-select_M"></em></p>
      </div>
      <div
        class="order-nav-list"
        v-show="isShowDateScope"
      >
        <p
          v-for="item in dateScopeKeys"
          v-bind:key="item.key"
          v-bind:class="{active:item.value==dateScope}"
          v-on:click="setCommissionDateScopeHandler(item.value)"
        >{{item.key}}<em class="iconfont_M icon-select_M"></em></p>
      </div>
    </div>
    <div class="reward-list">
      <div class="reward-total">合计：<span>¥{{totalMoney}}</span></div>
      <p class="reward-list-tit">奖励记录</p>
      <div
        class="reward-list-col"
        v-for="(item, index) in commissions"
        v-bind:key="index + ':' + item.orderID"
      >
        <div class="reward-col-other reward-col-other2 clearfix">
          <p style="height: 1.8125rem;" v-if="item.relatedPaySettlementOrderId !== 0">会员编号：{{item.platformAgentId}}</p>
          <p style="height: 1.8125rem;" >订单编号：{{item.orderID}}
            <template v-if="item.relatedPaySettlementOrderId==0">
              <!-- （{{item.nodeName}}） -->
            </template>
            <template v-else>
              （二级代理分润）
            </template>
          </p>
          <p style="height: 1.8125rem;">奖励来源：{{item.activityName}}</p>
          <p style="height: 1.8125rem;" v-if="item.relatedPaySettlementOrderId==0">订单信息：{{item.userPhone}}<span v-if="item.userName&&item.userName.length>0">（{{item.userName}}）</span></p>
          <p style="height: 1.8125rem;">发放时间：{{item.settlementDate | datetimeFormat('yyyy年MM月dd日')}}</p>
        </div>
        <p class="reward-col-num"><span class="font-red">+{{item.commission}}</span>元</p>
      </div>
    </div>
    <pull-load
      target-element="order-list"
      v-bind:bottom-method="loadMoreCommissions"
      v-bind:state="loadMoreState"
    ></pull-load>
    <div
      class="msk"
      v-show="mask"
      v-on:click="hideFilter()"
    ></div>
    <social-dialog
      title="正在加载"
      category="tips"
      v-bind:show="dialogShow"
    ></social-dialog>
    <!--我的奖励-->
    <dlr-calendar
      mode="day"
      :tabs="['day']"
      :end-date="new Date()"
      v-model="calendarVisible"
      @on-select="changeDateHandler">
    </dlr-calendar>
  </section>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import SocialHeader from '../../components/social-header.vue'
import SocialDialog from '../../components/social-dialog.vue'
import PullLoad from '../../components/pull-load.vue'
import * as types from '@/store/mutation-types'
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'

export default {
  components: {
    SocialHeader,
    SocialDialog,
    PullLoad
  },
  name: 'AccountCommission',
  data: function () {
    return {
      isShowCommissionType: false,
      isShowDateScope: false,
      dialogShow: false,
      loadMoreState: 0,
      calendarVisible: false,
      isChangeCommissionTypeDisabled: false
    }
  },
  created: function () {
    this.dialogShow = true
    changeDocumentTitle('我的奖励')
    var current = this
    if (this.$route.query.secondPlatformAgentId && this.$route.query.secondPlatformAgentId !== '') {
      this.setSecondPlatformAgentId(this.$route.query.secondPlatformAgentId)
      this.setCommissionType({ commissionType: 'RelatedPay' })
      this.isChangeCommissionTypeDisabled = true
    } else {
      this.setSecondPlatformAgentId('')
      this.setCommissionType({ commissionType: '' })
    }
    this.$store.dispatch('getCommissions').then(function (res) {
      current.dialogShow = false
      if (current.$store.getters.isCommissionPageEnd) {
        current.loadMoreState = 2
      }
      console.log('getCommissions.success')
    })
  },
  mounted: function () {
    var current = this;
    document.body.addEventListener('click', function () {
      if (current.isShowDateScope === true) {
        current.isShowDateScope = false
      }
      if (current.isShowCommissionType === true) {
        current.isShowCommissionType = false
      }
    })
  },
  computed: {
    ...mapGetters({
      commissions: 'commissions',
      commissionType: 'commissionType',
      dateScope: 'dateScope',
      commissionTypeKeys: 'commissionTypeKeys',
      dateScopeKeys: 'dateScopeKeys',
      totalMoney: 'totalMoney'
    }),
    mask: function () {
      return this.isShowCommissionType || this.isShowDateScope
    },
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapMutations({
      'setDate': 'SET_ACCOUNT_COMMISSION_DATE',
      'setSecondPlatformAgentId': 'SET_ACCOUNT_COMMISSION_SECOND_PLATFORMAGENTID',
      'setCommissionType': types.SET_ACCOUNT_COMMISSION_TYPE
    }),
    showCommissionType: function () {
      this.isShowDateScope = false
      this.isShowCommissionType = !this.isShowCommissionType
    },
    showDateScope: function () {
      this.isShowCommissionType = false
      this.isShowDateScope = !this.isShowDateScope
    },
    setCommissionTypeHandler: function (value) {
      this.dialogShow = true
      var current = this
      this.$store
        .dispatch('setCommissionType', { commissionType: value })
        .then(function () {
          current.dialogShow = false
        })
    },
    setCommissionDateScope: function (value) {
      this.dialogShow = true
      var current = this
      this.$store
        .dispatch('setCommissionDateScope', { dateScope: value })
        .then(function () {
          current.dialogShow = false
        })
    },
    setCommissionDateScopeHandler (dateScope) {
      this.isShowDateScope = false
      var current = this
      if (dateScope === '0') {
        this.dialogShow = true
        this.$store
        .dispatch('setCommissionDate', '')
        .then(function () {
          current.dialogShow = false
        })
      } else if (dateScope === '1') {
        this.calendarVisible = true
      }
    },
    changeDateHandler (date) {
      let newDate = `${date.year}-${date.month}-${date.day}`
      this.setDate(newDate)
      var current = this
      this.dialogShow = true
      this.$store
        .dispatch('setCommissionDate', newDate)
        .then(function () {
          current.dialogShow = false
        })
    },
    // 滚动加载更多
    loadMoreCommissions: function () {
      if (this.loadMoreState !== 0) {
        return false
      }
      this.loadMoreState = 1
      var current = this
      this.$store.dispatch('loadMoreCommissions').then(function () {
        current.loadMoreState = 0
        if (current.$store.getters.isCommissionPageEnd) {
          current.loadMoreState = 2
        }
        current.dialogShow = false
      })
    },
    hideFilter: function () {
      var current = this
      if (current.isShowSort === true) {
        current.isShowSort = false
      }
      if (current.isShowCategory === true) {
        current.isShowCategory = false
      }
    }
  },
  beforeDestroy: function () {
    // document.body.removeEventListener('click')
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/account/commission.vue